export const UPDATE_FILTER = 'ksk001/estateOverviewFilters/UPDATE_FILTER'
export const UPDATE_FILTERS = 'ksk001/estateOverviewFilters/UPDATE_FILTERS'

export const initialState = {
  vermarktungsart: 'kauf',
  order: 'asc',
  orderby: 'distance',
  perimeter: 10,
  location: null,
  mietpreis: null,
  kaufpreis: null,
  objektNr: null,
  wohnflaeche: null,
  objektart: null,
  zimmer: null,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE_FILTER:
      return {
        ...state,
        [payload.name]: payload.value,
        ...(payload.name === 'vermarktungsart' && payload.value === 'miete'
          ? { kaufpreis: null }
          : {}),
        ...(payload.name === 'vermarktungsart' && payload.value === 'kauf'
          ? { mietpreis: null }
          : {}),
      }
    case UPDATE_FILTERS:
      return {
        ...initialState,
        ...payload,
        ...(payload.vermarktungsart === 'miete' ? { kaufpreis: null } : {}),
        ...(payload.vermarktungsart === 'kauf' ? { mietpreis: null } : {}),
      }
    default:
      return state
  }
}

export const updateFilter = (name, value) => dispatch =>
  dispatch({
    type: UPDATE_FILTER,
    payload: { name, value },
  })

export const updateFilters = filters => dispatch =>
  dispatch({
    type: UPDATE_FILTERS,
    payload: filters,
  })
